import axios from '../../utils/AxiosUtils';
import { FETCH_PUSH_NOTIFICATIONS, LOADING } from "../types";
import MessageUtils from "../../utils/MessageUtils";
import i18n from "../../i18next";

export const createPushNotification = (brandId, formData, callback, copyPicture) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const url = `/push-notification?brandId=${brandId}&copyPicture=${copyPicture}`;

        axios().post(url, formData)
            .then(response => {
                if (formData.scheduled) {
                    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:pushNotificationActions.scheduledNotificationSuccess'));
                } else {
                    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:pushNotificationActions.instantNotificationSuccess'));

                }
            })
            .catch(error => {
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:pushNotificationActions.createError'));
            })
            .finally(() => {
                dispatch({ type: LOADING, payload: false });
                callback();
            })
    }
};

export const updatePushNotification = (notificationId, formData, callback, copyPicture) => {

    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/push-notification/${notificationId}?copyPicture=${copyPicture}`;

        axios().put(url, formData)
            .then(response => {
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:pushNotificationActions.updateSuccess'));
            })
            .catch(error => {
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:pushNotificationActions.updateError'));
            })
            .finally(() => {
                dispatch({ type: LOADING, payload: false });
                callback();
            })

    }

};

export const deletePushNotification = (pushNotificationId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/push-notification/${pushNotificationId}`;

        axios().delete(url)
            .then(response => {
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:pushNotificationActions.deleteNotificationSuccess'));
            })
            .catch(error => {
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:pushNotificationActions.deleteNotificationError'));
            })
            .finally(() => {
                dispatch({ type: LOADING, payload: false });
                callback();
            })
    }
};

export const fetchPushNotifications = (brandId, page, size) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/push-notification?brandId=${brandId}&page=${page}&size=${size}`;

        axios().get(url)
            .then(response => {
                dispatch({
                    type: FETCH_PUSH_NOTIFICATIONS,
                    payload: response.data
                })
            })
            .catch(error => {
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:pushNotificationActions.fetchError'));
            })
            .finally(() => {
                dispatch({ type: LOADING, payload: false });
            })
    }
};

export const uploadNotificationImage = (brandId, formData, callback, notificationId, enableSubmitBtn) => {
    return (dispatch) => {

        const file = formData.pictureUrl;
        const url = `/push-notification/image?brandId=${brandId}`;

        let newFormData = new FormData();
        newFormData.append('file', file)

        axios().post(url, newFormData)
            .then(response => dispatch(
                notificationId ?
                    updatePushNotification(notificationId, { ...formData, pictureUrl: response.data.path }, callback, false) :
                    createPushNotification(brandId, { ...formData, pictureUrl: response.data.path }, callback, false))
            )
            .catch(error => {
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:pushNotificationActions.uploadImageFailure'));
                enableSubmitBtn();
            })
    }
}



// WEBPACK FOOTER //
// ./src/actions/brands/AppNotificationActions.js